import { render, staticRenderFns } from "./newTreeViewer.vue?vue&type=template&id=3629435f&"
import script from "./newTreeViewer.vue?vue&type=script&lang=js&"
export * from "./newTreeViewer.vue?vue&type=script&lang=js&"
import style0 from "./newTreeViewer.vue?vue&type=style&index=0&id=3629435f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports